import './index.css';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AppointmentCalendarProvider from 'components/appointment_calendar_context';
import Loading from 'components/loading';
import Localization from 'l18n/l18n';
import AuthUser from 'models/auth';
import { SnackbarProvider } from 'notistack';
import AccountSettings from 'pages/account_settings/account_settings';
import Appointment from 'pages/appointment/appointment';
import AppointmentsCalendar from 'pages/appointments_calendar/appointments_calendar';
import PatientReport from 'pages/patient_report/patient_report';
import Patients from 'pages/patients/patients';
import PreviousAppointments from 'pages/previous_appointments/previous_appointments';
import React, {  useEffect,useState } from 'react';
import ReactDOM from 'react-dom/client';
import {Helmet} from 'react-helmet';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation} from 'react-router-dom';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import SideBar from './components/side_bar';
import ForgotPassword from './pages/forgot_password/forgot_password';
import Home from './pages/home/home'; //Write in TypeScript 
import SignIn from './pages/signin/signin'; //Write in JaveScript
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

;
// Create rtl cache
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
}); 
// eslint-disable-next-line no-unused-vars
function RequireAuth({ children }) { 
  let location = useLocation();

  if (!AuthUser.isSignIn) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

const theme = createTheme({
  direction: 'rtl',
  palette: {
    primary: {
      main: '#279BFF',
    },
    secondary: {
      main: '#CBE7FF',
    },
  },
});

function Index () {

  const [isLoading, setIsLoading] = useState(true);
  useEffect(()=>{
    Localization.init();
    AuthUser.init()
    .then((data)=>{
      setIsLoading(false);
    })
    .catch((error)=>{
      setIsLoading(false);
    });
  },[]);
  
  if (isLoading){
   
    return     <Loading isLoading={isLoading}/>;
  }
  /////////////////////////////////////////////
  /// Generate Sign In pages 
  ///
  if (!AuthUser.isSignIn){
    return <Routes>
            <Route path="/forgot-password" element={<ForgotPassword />} /> 
            <Route path="*" element={<SignIn />} /> 
          </Routes>;
     
  }
  /////////////////////////////////////////////
  /// Practitioner Sign In 
  ///
  return <SideBar > 
          
          <Routes>
            <Route path="/" element={<Home />} /> 
            <Route path="/appointments-calendar" element={<AppointmentCalendarProvider><AppointmentsCalendar /></AppointmentCalendarProvider>} /> 
            <Route path="/previous-appointments" element={<PreviousAppointments />} /> 
            <Route path="/patients" element={<Patients />} /> 
            <Route path="/patients/:patient_info_id" element={<PatientReport />} /> 
            <Route path="/appointment/:appointmentCalendarId" element={<Appointment />} /> 
            <Route path="/account-settings" element={<AccountSettings />} /> 
            <Route path="*" element={ <Navigate to="/" />} /> 
          </Routes> 
        </SideBar>;
}
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <CacheProvider value={cacheRtl}>
    <ThemeProvider theme={theme} >
    <SnackbarProvider>
      <BrowserRouter>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{Localization.translate['app_name']}</title>
            </Helmet>
          <Index />
    </BrowserRouter> 
    </SnackbarProvider>
    </ThemeProvider>
  </CacheProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorkerRegistration.unregister();

reportWebVitals();
